module.exports = __webpack_public_path__ + "img/urbi-03.31c069a0.jpg";